import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

export const Utility = {
  Gas: 'gas',
  Electricity: 'electricity',
  Both: 'both',
}

export default class StepWhichUtility extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>Which utility would you like a quote for?</p>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.utility === Utility.Gas}
            className={styles.formCheckInput}
            id={Utility.Gas}
            name="utility"
            value={Utility.Gas}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Utility.Gas}>Gas</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.utility === Utility.Electricity}
            className={styles.formCheckInput}
            id={Utility.Electricity}
            name="utility"
            value={Utility.Electricity}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Utility.Electricity}>Electricity</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.utility === Utility.Both}
            className={styles.formCheckInput}
            id={Utility.Both}
            name="utility"
            value={Utility.Both}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Utility.Both}>Both</label>
        </div>
      </>
    )
  }
}

StepWhichUtility.propTypes = {
  utility: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}